import './sentry.ts';
import './styles/tailwind.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { GlobalProvider } from './GlobalContext';
import { I18nextProvider } from 'react-i18next';
import { SnackbarProvider } from 'notistack';
import i18n from './i18n';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { FormAlert } from './components/snackBar/FormAlert';
import ReportComplete from './components/snackBar/ReportComplete';
import { applyKeyMUI } from './utils/mui';
import { pushNotificationService } from './services/PushNotificationService';

applyKeyMUI();

// Registra el service worker para notificaciones push
pushNotificationService.registerServiceWorker();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <I18nextProvider i18n={i18n}>
            <SnackbarProvider
                autoHideDuration={3500}
                maxSnack={10}
                dense
                Components={{
                    formAlert: FormAlert,
                    reportComplete: ReportComplete,
                }}
            >
                <GlobalProvider>
                    <App />
                </GlobalProvider>
            </SnackbarProvider>
        </I18nextProvider>
    </LocalizationProvider>,
);
